import { render, staticRenderFns } from "./ButtonIcon.vue?vue&type=template&id=be757950&scoped=true"
import script from "./ButtonIcon.vue?vue&type=script&lang=ts"
export * from "./ButtonIcon.vue?vue&type=script&lang=ts"
import style0 from "./ButtonIcon.vue?vue&type=style&index=0&id=be757950&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be757950",
  null
  
)

export default component.exports